<template>
    <div class="csp">
        <!-- cabeçalho: dados do processo (somente leitura, vindos do ERP) e ações -->
        <section class="ec-card">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone"><i class="fa-solid fa-clipboard-list"></i></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">{{ processo_seletivo.descricaoprocesso || 'Processo seletivo' }}</h2>
                    <p class="ec-card__subtitulo">Dados importados do ERP</p>
                </div>
                <span class="ec-card__extra">
                    <span class="ec-card__etiqueta" v-if="modalidade">{{ modalidade }}</span>
                    <span class="ec-status" :class="'ec-status--'+situacaoInscricoes.variante">{{ situacaoInscricoes.texto }}</span>
                </span>
            </header>
            <div class="ec-card__corpo">
                <dl class="csp-dados">
                    <div>
                        <dt>Período de inscrições</dt>
                        <dd>{{ formatarData(processo_seletivo.datainicio) }} a {{ formatarData(processo_seletivo.datatermino) }}</dd>
                    </div>
                    <div>
                        <dt>Tipo de processo</dt>
                        <dd>{{ processo_seletivo.descricaotipoprocesso || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Ano / semestre</dt>
                        <dd>{{ processo_seletivo.ano || '—' }}<template v-if="processo_seletivo.semestre"> / {{ processo_seletivo.semestre }}º</template></dd>
                    </div>
                    <div>
                        <dt>Chamada</dt>
                        <dd>{{ processo_seletivo.chamada || '—' }}</dd>
                    </div>
                    <div>
                        <dt>ID do processo no ERP</dt>
                        <dd>{{ processo_seletivo.idProcesso || '—' }}</dd>
                    </div>
                </dl>

                <ul class="csp-totais">
                    <li><b>{{ turmas.length }}</b> turma(s)</li>
                    <li><b>{{ cursos.length }}</b> curso(s)</li>
                    <li v-if="resumoPolos.total>0">
                        <b>{{ resumoPolos.exportados }}/{{ resumoPolos.total }}</b> polo(s) no CRM
                        <span v-if="resumoPolos.exportados<resumoPolos.total" class="ec-status ec-status--aguardando">{{ resumoPolos.total-resumoPolos.exportados }} pendente(s)</span>
                    </li>
                </ul>

                <div class="ec-form-acoes">
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary"><b-icon icon="arrow-left"></b-icon> Voltar</a>
                    <button type="button" class="btn btn-primary" :disabled="exportando || turmas.length==0" :title="turmas.length==0 ? 'Não há turmas vinculadas para exportar' : ''" @click="confirmarExportacao()">
                        <b-icon icon="cloud-upload"></b-icon> {{ exportando ? 'Exportando...' : 'Exportar para o CRM (Rubeus)' }}
                    </button>
                </div>
            </div>
        </section>

        <!-- resultado da última exportação: fica visível até o usuário fechar -->
        <section class="ec-card csp-resultado" v-if="resultado" :class="'csp-resultado--'+resultado.variante" role="status" aria-live="polite">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone">
                    <b-icon :icon="resultado.variante=='sucesso' ? 'check-circle-fill' : (resultado.variante=='erro' ? 'x-circle-fill' : 'exclamation-triangle-fill')"></b-icon>
                </span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">{{ resultado.titulo }}</h2>
                    <p class="ec-card__subtitulo">{{ resultado.subtitulo }}</p>
                </div>
                <span class="ec-card__extra">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="recarregar()" v-if="resultado.ofertas.length>0" title="Recarrega a página para atualizar a situação dos polos">
                        <b-icon icon="arrow-clockwise"></b-icon> Atualizar situação
                    </button>
                    <button type="button" class="close ml-1" aria-label="Fechar" @click="resultado=null"><span aria-hidden="true">&times;</span></button>
                </span>
            </header>
            <div class="ec-card__corpo ec-card__corpo--flush" v-if="resultado.ofertas.length>0">
                <ul class="csp-lista">
                    <li v-for="oferta,i in resultadoOrdenado" :key="i" class="csp-lista__item">
                        <span v-if="oferta.sucesso" class="ec-status ec-status--sucesso"><b-icon icon="check-lg"></b-icon> Exportada</span>
                        <span v-else class="ec-status ec-status--erro"><b-icon icon="x-lg"></b-icon> Falhou</span>
                        <div class="csp-lista__info">
                            <span class="csp-lista__nome">{{ oferta.nome }}</span>
                            <small v-if="!oferta.sucesso" class="text-danger">{{ oferta.mensagem }}</small>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <!-- turmas (ofertas) vinculadas ao processo -->
        <section class="ec-card">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone"><i class="fa-solid fa-users"></i></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">Turmas vinculadas</h2>
                    <p class="ec-card__subtitulo">Ofertas enviadas ao CRM e os polos em que cada uma é oferecida.</p>
                </div>
                <span class="ec-card__extra"><span class="ec-card__etiqueta">{{ turmas.length }}</span></span>
            </header>
            <div class="ec-card__corpo ec-card__corpo--flush">
                <p v-if="turmas.length==0" class="csp-vazio">
                    Nenhuma turma vinculada a este processo. Configure as turmas dos cursos na tela de oferta de processo seletivo.
                </p>
                <ul v-else class="csp-lista">
                    <li v-for="turma,i in turmas" :key="turma.id || i" class="csp-turma">
                        <div class="csp-turma__linha">
                            <div class="csp-turma__info">
                                <span class="csp-turma__nome">{{ turma.descricaoofertapse || turma.descricaocompleta }}</span>
                                <span class="csp-turma__meta">
                                    <span v-if="turma.descricaociclo">{{ turma.descricaociclo }}</span>
                                    <span v-if="turma.codigoofertapse">Oferta {{ turma.codigoofertapse }}</span>
                                    <span>Aulas: {{ formatarData(turma.datainicio) }} a {{ formatarData(turma.datatermino) }}</span>
                                    <span>Inscrições: {{ formatarData(turma.datainicioinscricao) }} a {{ formatarData(turma.dataterminoinscricao) }}</span>
                                    <span v-if="vagas(turma)">{{ vagas(turma) }}</span>
                                </span>
                            </div>
                            <div class="csp-turma__extra">
                                <span v-if="turma.situacaoturma" class="ec-status ec-status--neutro">{{ turma.situacaoturma }}</span>
                                <span class="csp-valor" :class="{ 'csp-valor--isento': valorOferta(turma)=='Isento' }">{{ valorOferta(turma) }}</span>
                                <a class="btn btn-outline-primary btn-sm" :href="'/Access/Unity/Unitie/'+unidade.id+'/captacao/'+turma.id" title="Inscrições recebidas do CRM para esta turma">
                                    <i class="fa-solid fa-satellite-dish"></i> WebHooks
                                </a>
                            </div>
                        </div>
                        <div v-if="(turma.polos_turma || []).length>0" class="csp-polos">
                            <span class="csp-polos__rotulo">Polos:</span>
                            <span v-for="polo in turma.polos_turma" :key="polo.id" class="csp-polo" :class="polo.idexportacao>0 ? 'csp-polo--ok' : 'csp-polo--pendente'"
                                :title="(polo.idexportacao>0 ? 'Exportado para o CRM' : 'Ainda não exportado para o CRM') + ' · Empresa ' + polo.idempresapolo + ' / Unidade ' + polo.idunidadepolo">
                                <b-icon :icon="polo.idexportacao>0 ? 'check-circle-fill' : 'clock'"></b-icon>
                                {{ polo.descricaopolo }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <!-- cursos do processo -->
        <details class="ec-card" :open="cursos.length<=10">
            <summary class="ec-card__cabecalho">
                <span class="ec-card__icone"><i class="fa-solid fa-graduation-cap"></i></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">Cursos do processo</h2>
                    <p class="ec-card__subtitulo">Cursos cadastrados no ERP para este processo seletivo.</p>
                </div>
                <span class="ec-card__extra"><span class="ec-card__etiqueta">{{ cursos.length }}</span></span>
            </summary>
            <div class="ec-card__corpo ec-card__corpo--flush">
                <p v-if="cursos.length==0" class="csp-vazio">Nenhum curso encontrado para este processo.</p>
                <div v-else class="table-responsive">
                    <table v-ec-datatable class="table table-sm table-hover ec-tabela">
                        <thead class="ec-thead">
                            <tr>
                                <th class="text-left">Curso</th>
                                <th class="text-left">Documento</th>
                                <th class="text-center">Período</th>
                                <th class="text-center">Tipo</th>
                                <th class="text-left">Nível de ensino</th>
                                <th class="text-left">Modalidade</th>
                                <th class="text-center">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="curso,i in cursos" :key="i">
                                <td class="text-left" data-label="Curso">
                                    <span class="ec-tabela__principal">{{ curso.descricaocurso }}</span>
                                    <small class="ec-tabela__secundario">Cód. {{ curso.codigocurso }}<template v-if="curso.codigoidentificacao"> · Ident. {{ curso.codigoidentificacao }}</template></small>
                                </td>
                                <td class="text-left" data-label="Documento">{{ curso.descricaodocumento || '—' }}</td>
                                <td class="text-center" data-label="Período">{{ curso.periodo || '—' }}</td>
                                <td class="text-center" data-label="Tipo">{{ curso.tipocurso || '—' }}</td>
                                <td class="text-left" data-label="Nível de ensino">{{ curso.descricaonivelensino || '—' }}</td>
                                <td class="text-left" data-label="Modalidade">{{ curso.descricaomodalidade || '—' }}</td>
                                <td class="text-center" data-label="Situação">
                                    <span v-if="cursoAtivo(curso)" class="ec-status ec-status--sucesso">Ativo</span>
                                    <span v-else class="ec-status ec-status--neutro">Inativo</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </details>

        <loading id="exportarProcessoSeletivo" titulo="Exportando ofertas para o CRM..." :sem-padding="true" gif-carregando="/imagens/carregando.gif" @cancelaRequisicao="cancelarRequisicao()"></loading>
    </div>
</template>

<script>
export default{
    props:{
        unidade:{
            type:Object,
            required:true
        },
        urlSistema:{
            type:String,
            required:true
        },
        processo:{
            type:Object,
            required:true
        },
        // mantidos por compatibilidade com a view (a tela é somente de visualização)
        visualizar:Boolean,
        edit:Boolean,
        nomeFormulario:String,
        metodoFormulario:String,
        linkAction:String,
        usuarioAutenticado:Object,
        usuarios:[String, Array],
    },
    data(){
        return{
            processo_seletivo:{},
            exportando:false,
            cancelTokenSource:null,
            resultado:null,
        }
    },
    created(){
        this.processo_seletivo = Object.assign({}, this.processo, {
            datainicio: this.paraData(this.processo.datainicio),
            datatermino: this.paraData(this.processo.datatermino),
        })
    },
    computed:{
        turmas(){
            return this.processo_seletivo.turmas || []
        },
        cursos(){
            return this.processo_seletivo.cursos || []
        },
        modalidade(){
            return this.processo_seletivo.modality ? this.processo_seletivo.modality.modalidade : null
        },
        situacaoInscricoes(){
            const inicio = this.processo_seletivo.datainicio
            const termino = this.processo_seletivo.datatermino
            if(!inicio || !termino) return { texto:'Sem período', variante:'neutro' }
            const hoje = new Date()
            hoje.setHours(0,0,0,0)
            const fim = new Date(termino)
            fim.setHours(23,59,59,999)
            if(hoje < inicio) return { texto:'Inscrições em breve', variante:'pendente' }
            if(hoje > fim) return { texto:'Inscrições encerradas', variante:'neutro' }
            return { texto:'Inscrições abertas', variante:'sucesso' }
        },
        resumoPolos(){
            const polos = this.turmas.reduce((lista, turma) => lista.concat(turma.polos_turma || []), [])
            return { total: polos.length, exportados: polos.filter(p => p.idexportacao > 0).length }
        },
        // falhas primeiro, para o usuário ver logo o que precisa de atenção
        resultadoOrdenado(){
            return this.resultado.ofertas.slice().sort((a, b) => a.sucesso - b.sucesso)
        },
    },
    methods:{
        paraData(valor){
            if(!valor) return null
            const data = new Date(valor)
            return isNaN(data.getTime()) ? null : data
        },
        formatarData(valor){
            const data = valor instanceof Date ? valor : this.paraData(valor)
            if(!data || data.getFullYear() < 1971) return '—'
            return data.toLocaleDateString('pt-BR')
        },
        // formato aaaa-mm-dd esperado pela API de exportação
        dataIso(data){
            if(!data) return null
            const mes = String(data.getMonth()+1).padStart(2,'0')
            const dia = String(data.getDate()).padStart(2,'0')
            return data.getFullYear() + '-' + mes + '-' + dia
        },
        vagas(turma){
            const minimo = turma.tamanhoturmaminimo, maximo = turma.tamanhoturmaximo
            const temMin = minimo !== null && minimo !== undefined && minimo !== '' && minimo >= 0
            const temMax = maximo !== null && maximo !== undefined && maximo !== '' && maximo > 0
            if(temMin && temMax) return 'Vagas: ' + minimo + ' a ' + maximo
            if(temMax) return 'Até ' + maximo + ' vagas'
            if(temMin) return 'Mínimo ' + minimo + ' alunos'
            return null
        },
        valorOferta(turma){
            const valor = parseFloat(turma.valoroferta)
            if(isNaN(valor)) return '—'
            return valor == 0 ? 'Isento' : this.$root.numberToReal(valor)
        },
        cursoAtivo(curso){
            return curso.ativo === true || curso.ativo == 1 || String(curso.ativo).toUpperCase() == 'S' || String(curso.ativo).toLowerCase() == 'ativo'
        },
        recarregar(){
            window.location.reload()
        },
        avisar(mensagem,variante,titulo){
            this.$bvToast.toast(mensagem, {
                title: titulo,
                variant: variante,
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: variante=='danger' ? 8000 : 4000,
            })
        },
        confirmarExportacao(){
            const mensagem = 'Exportar ' + this.turmas.length + ' turma(s) deste processo para o CRM (Rubeus)? As ofertas já existentes no CRM serão atualizadas.'
            this.$bvModal.msgBoxConfirm(mensagem, {
                title: 'Exportar para o CRM',
                okTitle: 'Exportar',
                cancelTitle: 'Cancelar',
                okVariant: 'primary',
                cancelVariant: 'outline-primary',
                centered: true,
            }).then(confirmou => {
                if(confirmou) this.exportarPSE()
            })
        },
        cancelarRequisicao(){
            if(this.cancelTokenSource){
                this.cancelTokenSource.cancel('Exportação cancelada pelo usuário')
            }
        },
        mensagemErro(erros){
            if(!erros) return 'Erro não informado pelo CRM.'
            if(typeof erros === 'string') return erros
            // o CRM devolve objeto/array de mensagens; achata em uma linha legível
            const lista = []
            const coletar = v => {
                if(v === null || v === undefined) return
                if(typeof v === 'object') Object.values(v).forEach(coletar)
                else lista.push(String(v))
            }
            coletar(erros)
            return lista.length ? lista.join(' · ') : JSON.stringify(erros)
        },
        lerRetornoOferta(retorno){
            let resposta = {}
            try{
                resposta = typeof retorno.resposta === 'string' ? JSON.parse(retorno.resposta) : (retorno.resposta || {})
            }catch(e){
                resposta = { success:false, errors: retorno.resposta }
            }
            return {
                nome: retorno.dadosOferta ? retorno.dadosOferta.nome : 'Oferta',
                sucesso: !!resposta.success,
                mensagem: resposta.success ? '' : this.mensagemErro(resposta.errors),
            }
        },
        exportarPSE(){
            this.exportando = true
            this.resultado = null
            this.cancelTokenSource = axios.CancelToken.source()
            $('#exportarProcessoSeletivo').modal('show')

            const formData = new FormData()
            formData.append('dadosPse', JSON.stringify(this.processo_seletivo))
            formData.append('datasPse', JSON.stringify({
                datainicio: this.dataIso(this.processo_seletivo.datainicio),
                datatermino: this.dataIso(this.processo_seletivo.datatermino),
            }))

            axios.post('/api/v1/Crm/exportarPSERubeus/' + this.unidade.id, formData, { cancelToken: this.cancelTokenSource.token })
                .then(response => {
                    if(response.data.erro){
                        this.resultado = { variante:'erro', titulo:'Não foi possível exportar o processo seletivo', subtitulo:'Resposta: ' + this.mensagemErro(response.data.erro), ofertas:[] }
                        this.avisar('Não foi possível exportar o processo seletivo.', 'danger', 'Erro na exportação')
                        return
                    }
                    const retorno = (response.data.dadosPse && response.data.dadosPse.original) || {}
                    const ofertas = (retorno.retornos || []).map(r => this.lerRetornoOferta(r))
                    const falhas = ofertas.filter(o => !o.sucesso).length

                    if(retorno.resposta_requisicao && retorno.resposta_requisicao.success === false){
                        this.resultado = { variante:'erro', titulo:'O CRM recusou o processo seletivo', subtitulo: this.mensagemErro(retorno.resposta_requisicao.errors), ofertas }
                        this.avisar('O CRM recusou o processo seletivo.', 'danger', 'Erro na exportação')
                    }else if(falhas > 0){
                        this.resultado = { variante:'alerta', titulo:'Exportação concluída com pendências', subtitulo: (ofertas.length-falhas) + ' de ' + ofertas.length + ' oferta(s) exportada(s). Corrija as falhas abaixo e exporte novamente.', ofertas }
                        this.avisar(falhas + ' oferta(s) não foram exportadas.', 'warning', 'Exportação com pendências')
                    }else{
                        this.resultado = { variante:'sucesso', titulo:'Processo seletivo exportado para o CRM', subtitulo: ofertas.length + ' oferta(s) exportada(s) com sucesso.', ofertas }
                        this.avisar('Processo seletivo exportado com sucesso.', 'success', 'Exportação concluída')
                    }
                })
                .catch(erro => {
                    if(axios.isCancel(erro)){
                        this.avisar('A exportação foi cancelada.', 'warning', 'Exportação cancelada')
                        return
                    }
                    console.log(erro)
                    const detalhe = erro.response && erro.response.data ? (erro.response.data.message || erro.response.data.erro) : null
                    this.resultado = { variante:'erro', titulo:'Erro ao exportar para o CRM', subtitulo: detalhe ? String(detalhe) : 'Verifique a conexão e tente novamente.', ofertas:[] }
                    this.avisar('Erro ao exportar para o CRM. Tente novamente.', 'danger', 'Erro na exportação')
                })
                .finally(() => {
                    this.exportando = false
                    $('#exportarProcessoSeletivo').modal('hide')
                })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.csp { text-align: left; }

.csp-dados {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 1rem 1.5rem;
    margin: 0 0 1rem;

    dt {
        margin-bottom: .15rem;
        font-size: .72rem;
        font-weight: 600;
        letter-spacing: .03em;
        text-transform: uppercase;
        color: $ec-texto-suave;
    }

    dd {
        margin: 0;
        font-weight: 600;
        color: $ec-texto;
    }
}

.csp-totais {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .5rem 1.25rem;
    margin: 0;
    padding: .75rem 0 0;
    list-style: none;
    border-top: 1px solid $ec-borda;
    font-size: .85rem;
    color: $ec-texto-suave;

    li { display: inline-flex; align-items: center; gap: .4rem; }
    b { color: $ec-texto; }
}

.csp-vazio {
    margin: 0;
    padding: 1.25rem;
    color: $ec-texto-suave;
}

.csp-lista {
    margin: 0;
    padding: 0;
    list-style: none;
}

.csp-lista__item {
    display: flex;
    align-items: flex-start;
    gap: .75rem;
    padding: .6rem 1.25rem;
    border-top: 1px solid $ec-borda;

    &:first-child { border-top: 0; }
}

.csp-lista__info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.csp-lista__nome { font-weight: 600; overflow-wrap: anywhere; }

.csp-resultado {
    &--sucesso .ec-card__icone { color: $green; background: rgba($green, .12); }
    &--alerta .ec-card__icone { color: darken($orange, 10%); background: rgba($orange, .12); }
    &--erro .ec-card__icone { color: $red; background: rgba($red, .1); }
}

.csp-turma {
    border-top: 1px solid $ec-borda;

    &:first-child { border-top: 0; }
}

.csp-turma__linha {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem 1rem;
    padding: .8rem 1.25rem .5rem;
}

.csp-turma__info {
    flex: 1 1 320px;
    min-width: 0;
}

.csp-turma__nome {
    display: block;
    font-weight: 700;
    color: $ec-petroleo-escuro;
    overflow-wrap: anywhere;
}

.csp-turma__meta {
    display: flex;
    flex-wrap: wrap;
    gap: .1rem 1rem;
    font-size: .8rem;
    color: $ec-texto-suave;
}

.csp-turma__extra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem .75rem;
}

.csp-valor {
    font-weight: 700;
    color: $ec-texto;
    white-space: nowrap;

    &--isento { color: $green; }
}

.csp-polos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .35rem;
    padding: 0 1.25rem .8rem;
}

.csp-polos__rotulo {
    font-size: .75rem;
    font-weight: 600;
    color: $ec-texto-suave;
}

.csp-polo {
    display: inline-flex;
    align-items: center;
    gap: .3rem;
    padding: .15rem .55rem;
    border-radius: 999px;
    font-size: .75rem;
    border: 1px solid transparent;

    &--ok { color: darken($green, 12%); background: rgba($green, .08); border-color: rgba($green, .25); }
    &--pendente { color: darken($orange, 15%); background: rgba($orange, .08); border-color: rgba($orange, .3); }
}

@media (max-width: 575.98px) {
    .csp-turma__linha,
    .csp-lista__item { padding-left: 1rem; padding-right: 1rem; }
    .csp-polos { padding: 0 1rem .8rem; }
}
</style>
